import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Societe from "../../services/Societe";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../services/SellingService";
import OrderService from "../../services/PosService/OrderService";
import FactureNonConfirme from "../ProductSellBTOB/Table/FactureNonConfirme";
import withLoader from "../../components/layouts/WithLoader";
import EtatMagasinTable from "./Table/EtatMagasinTable";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";
const EtatMagasin = ({ startLoading, stopLoading }) => {

  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [etatMagasin, setEtatMagasin] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const animatedComponents = makeAnimated();
  const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amountToPay, setAmountToPay] = useState(0);
  const [totalAmountNotPayed, setTotalAmountNotPayed] = useState(0);
  const [amountToPayNotPayed, setAmountToPayNotPayed] = useState(0);

  const [allMagasin, setAllMagasin] = useState([]);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] =
    useState("");

  const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption();
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label)
  };
  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // Set seconds to 00 if it's a datetime-local input
      : selectedValue + "T00:00:00"; // For date input, append "T00:00:00" to set the first second of the day

    setDateBegin(updatedValue);
  };


  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // If time exists, append ":59" to set seconds to 59
      : selectedValue + "T23:59:59"; // If it's a date-only input, append "T23:59:59" for the last second of the day

    setDateEnd(updatedValue);
  };
  const onGetFacturesByFiltersHandler = () => {
    startLoading();
    OrderService.getChiffreOrderBySocieteAndShop(getCurrentUserId(), magasinId, dateBegin, dateEnd)
      .then((response) => {
        if (response.data.success) {
          setEtatMagasin(response.data.success);

        }
        setTotalAmount(response.data.totalAmount);
        setAmountToPay(response.data.amountPayed);

        setTotalAmountNotPayed(response.data.totalAmountNotPayed);
        setAmountToPayNotPayed(response.data.amountPayedNotPayed)
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : facture last month not deleted");
      })
      .finally(() => {
        stopLoading();
      });
  };
  useEffect(() => {

    CashRegisterService.getAllShop(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          response.data.success.map((element) => {
            setAllMagasin((oldArray) => [
              ...oldArray,
              { value: element.id, label: element.ref + "-" + element.name },
            ]);
          })
          // setAvailableShop(response.data.success);

        } else {
          console.log("error in getAllShop", response.data.success);
        }
      })
      .catch((e) => {
        console.log("error in getAllShop", e);
      });

  }, []);


  const cardStatistique = () => {
    return (
      <>
        <section class="content">
          <div className="container-fluid">
            <div className="row">
              {totalAmount !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Montant des tickets partiement payé</span>
                      <span className="info-box-number">{totalAmount}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {amountToPay !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Reste à payer</span>{" "}
                      <span className="info-box-number">{amountToPay}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    );
  };
  const cardStatistiqueNotPayed = () => {
    return (
      <>
        <section class="content">
          <div className="container-fluid">
            <div className="row">
              {totalAmountNotPayed !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Montant des tickets non payé</span>
                      <span className="info-box-number">{totalAmountNotPayed}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {amountToPayNotPayed !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">A payer</span>{" "}
                      <span className="info-box-number">{amountToPayNotPayed}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Vente
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Vente B2C
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Etat de Magasin
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>


      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputClientCompany">
                          Choisir le magasin
                        </label>
                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={magasinSelectedOption}
                          onChange={onChangeSelectedMagasin}
                          options={allMagasin}
                          placeholder={magasinSelectPlaceHolder}
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetFacturesByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {cardStatistique()}
      {cardStatistiqueNotPayed()}

      {etatMagasin && Array.isArray(etatMagasin) && (
        <section className="content ">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <EtatMagasinTable listEtat={etatMagasin} />
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">Indications</h3>
                </div>
                <div class="card-body">

                  <div class="row"><b>Vente</b></div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      CA : chiffre d'affaires : le montant total des ventes
                    </label>
                  </div>

                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Payé : le montant des tickets totalement payés
                    </label>
                  </div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Partiellement payé	 : le montant payé par le client des tickets partiellement payés dans la période choisie
                    </label>
                  </div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Crédit : le montant payé par le client des tickets crédits  dans la période choisie
                    </label>
                  </div>

                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Non payé	 : le montant total des tickets Créés et non payés.
                    </label>
                  </div>
                  <div class="row"><b>Achats</b></div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Achats Total : le montant total des achats
                    </label>
                  </div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Achats payés : le montant total des achats des tickets totalement payés
                    </label>
                  </div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Achats partiellement payés : le montant total des achats des tickets partielement payés
                    </label>
                  </div>
                  <div class="row">
                    <label htmlFor="inputClientCompany">
                      Achats non payés : le montant total des achats des tickets non payés
                    </label>
                  </div>



                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};
export default withLoader(EtatMagasin);
